import { render, staticRenderFns } from "./choseStock.vue?vue&type=template&id=6f20afe0&scoped=true&"
import script from "./choseStock.vue?vue&type=script&lang=js&"
export * from "./choseStock.vue?vue&type=script&lang=js&"
import style0 from "./choseStock.vue?vue&type=style&index=0&id=6f20afe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20afe0",
  null
  
)

export default component.exports